import { atom } from "jotai";
import { ApiEndPoint } from "../../_helper/constant/api-types";

export const CONSULTATION_APIS = {
  TAGS: "master_data/tags/",
  ADDICTIONS: "master_data/addiction/",
  ALLERGY: "master_data/allergies/",
  PATIENT_HISTORY: "master_data/medical_history/",
  CLINIC_SERVICES: ApiEndPoint.CLINIC_SERVICES,
};

export const INITIAL_CONSULTATION_JSON = [
  {
    id: 1,
    label: "Addictions",
    offset: `ADDICTIONS`,
    key: "customField",
  },
  {
    id: 2,
    label: "Allergy",
    offset: "ALLERGY",
    key: "customField",
  },
  {
    id: 3,
    label: "Patient History",
    offset: "PATIENT_HISTORY",
    key: "customField",
  },
  {
    id: 4,
    label: "Billing",
    offset: "CLINIC_SERVICES",
    key: "customField",
  },
  { id: 5, label: "Vitals", key: "vitals" },
  { id: 6, label: "Medicine Details", key: "medicineTable" },
  {
    id: 7,
    label: "Advice & Direction",
    key: "adviceDirection",
  },
  { id: 8, label: "Next Visit", key: "nextVisit" },
  { id: 9, label: "Observation", key: "observation" },
];

export const prescriptionSetupAtom = atom({
  marginLeft: "0",
  marginRight: "0",
  marginTop: "0",
  marginBottom: "0",
  pageSize: "A4",
  signatureImg: "",
  signatureText: "",
  signatureHeight: "1",
  signatureWidth: "1",
  pageOrdering: INITIAL_CONSULTATION_JSON,
  printSignature: false,
});

const INITIAL_CONSULTATION_ORDERING = [
  "complaints",
  "addictions",
  "allergy",
  "patienthistory",
  "vitals",
  "diagnosis",
  "medicinedetails",
  "advice&direction",
  "test&investigation",
  "nextvisit",
  "observation",
  "billing",
];

export const setInitialConsultationOrdering = (consultation) => {
  const initialOrdering = INITIAL_CONSULTATION_ORDERING;
  const labelMap = consultation.reduce((map, item) => {
    map[item.label.replace(/\s+/g, "").toLowerCase()] = item;
    return map;
  }, {});

  return initialOrdering.map((orderItem) => labelMap[orderItem]);
};

export const consultationJSONAtom = atom(INITIAL_CONSULTATION_JSON);
export const tagTypesAtom = atom([]);

// export const CONSULTATION_JSON = [
//   {
//     id: 1,
//     label: "Complaints",
//     offset: ApiEndPoint.QP_CM_TAGS,
//     query: "?tag_type=4",
//     key: " customField",
//     tagId: 4,
//   },
//   {
//     id: 2,
//     label: "Addictions",
//     offset: `master_data/addictions/`,
//     query: "?",
//     key: " customField",
//   },
//   {
//     id: 3,
//     label: "Allergy",
//     offset: ApiEndPoint.QP_CM_ALLERGIES,
//     query: "?action=getAllergies&frontend=True",
//     key: "customField",
//   },
//   {
//     id: 4,
//     label: "Patient History",
//     offset: ApiEndPoint.QP_CM_PATIENT_HISTORY,
//     query: "?action=getMedicalHistory&frontend=True",
//     key: "customField",
//   },
//   { id: 5, label: "Vitals", offset: "", key: "vitals" },
//   {
//     id: 6,
//     label: "Diagnosis",
//     offset: ApiEndPoint.QP_CM_TAGS,
//     query: "?action=getTags&frontend=True&tag_type=5",
//     key: " customField",
//     tagId: 5,
//   },
//   { id: 7, label: "Medicine Details", offset: "", key: "medicineTable" },
//   {
//     id: 8,
//     label: "Advice & Direction",
//     offset: ApiEndPoint.ADVICES,
//     query: "?action=getAdvices&frontend=True",
//     key: "adviceDirection",
//   },
//   {
//     id: 9,
//     label: "Test & Investigation",
//     offset: ApiEndPoint.QP_CM_TAGS,
//     query: "?action=getTags&frontend=True&tag_type=6",
//     key: "customField",
//     tagId: 6,
//   },
//   { id: 10, label: "Next Visit", offset: "", key: "nextVisit" },
// ];

export const MEDICINE_FIELDS = [
  { id: 1, label: "Medicine name", width: "230px", key: "medicineName" },
  { id: 2, label: "Dosage", width: "90px", key: "dosage" },
  { id: 3, label: "Unit", width: "90px", key: "unit" },
  { id: 4, label: "When", width: "90px", key: "when" },
  { id: 5, label: "Frequency", width: "90px", key: "frequency" },
  { id: 6, label: "Duration", width: "90px", key: "duration" },
  { id: 7, label: "Notes", width: "130px", key: "notes" },
];

export const medicineFormAtom = atom({
  id: null,
  medicineName: "",
  recentlyUsedCount: 0,
  genericName: {
    name: "",
  },
  medicineType: {
    name: "",
    label: "",
  },
  dosage: {
    label: "",
    name: "",
  },
  unit: {
    label: "",
    name: "",
  },
  when: {
    label: "",
    name: "",
  },
  frequency: {
    label: "",
    name: "",
  },
  duration: "",
  notes: {
    name: "",
  },
  timing: {
    name: "",
  },
  category: {
    name: "",
  },
});

export const previousVisitsAtom = atom([]);
